import React from "react";
import _ from "lodash";
import RecipeBox from "./recipe/RecipeBox";
import { VseAPI } from "apis";
import PopupWrapper from "../common/PopupWrapper";

class ChecksView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,

      checks: null,
    };
  }

  async componentDidMount() {
    document.title = `Checks | VSE`;

    this.setState({ isLoading: true });
    try {
      const { checks } = await VseAPI.getAllChecks();
      const recipesById = _.keyBy(this.props.recipes, "id");
      const checksWithRecipe = _.map(checks, (c) => {
        if (c.associated_recipes) {
          c.associated_recipes = _.map(c.associated_recipes, (ar) => {
            ar.recipe = recipesById[ar.id];
            return ar;
          });
        }
        return c;
      });
      this.setState({ checks: checksWithRecipe, errMsg: null });
    } catch (err) {
      this.setState({ errMsg: "Error loading checks" });
    }

    this.setState({ isLoading: false });
  }

  render() {
    const { isLoading, errMsg, checks } = this.state;

    return (
      <>
        <div>
          <table
            className="border shadow table w-full text-sm"
            style={{ marginBottom: "500px" }}
          >
            <thead className="border-b bg-gray-200 text-xs text-blue-800">
              <tr>
                <th className="border px-2 py-1">Id</th>
                <th className="border px-2 py-1">Name</th>
                <th className="border px-2 py-1">Associated Recipes</th>
              </tr>
            </thead>
            <tbody className="bg-white font-mono text-gray-900">
              {checks &&
                checks.map((r) => {
                  return (
                    <tr key={r.id} className="border-b hover:bg-gray-100">
                      <td className="whitespace-no-wrap border px-2 py-1 font-sans font-semibold">
                        {r.id}
                      </td>
                      <td className="whitespace-no-wrap border px-3 py-1 text-left">
                        {r.name}
                      </td>

                      <td className="whitespace-no-wrap border px-3 py-1 text-left">
                        {r.associated_recipes.map((ar) => {
                          return (
                            <div key={ar.id} className="mb-1">
                              <AssociatedRecipeBox
                                recipe={ar}
                              ></AssociatedRecipeBox>
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

const AssociatedRecipeBox = (props) => {
  const { recipe } = props;
  // id
  // name
  // status
  // recipe

  return (
    <>
      <PopupWrapper
        place="bottom left"
        hideArrow={true}
        triggerElement={
          <div className="rounded border cursor-pointer bg-gray-200 px-2">
            {recipe.id} - {recipe.name}
          </div>
        }
        popupElement={
          <div
            className="overflow-y-auto border-4 border-gray-600 shadow-lg"
            style={{ marginTop: "-9px", maxHeight: "500px" }}
          >
            <RecipeBox item={recipe.recipe}></RecipeBox>
          </div>
        }
      ></PopupWrapper>
    </>
  );
};

export default ChecksView;
